import { datadogLogs } from "@datadog/browser-logs";
import { datadogRum } from "@datadog/browser-rum";

// Rum config
const datadogRumconfig = {
  applicationId: process.env.NEXT_PUBLIC_DATADOG_APPLICATION_ID,
  clientToken: process.env.NEXT_PUBLIC_DATADOG_CLIENT_TOKEN,
  site: "datadoghq.eu",
  service: process.env.NEXT_PUBLIC_DATADOG_SERVICE,
  env: process.env.NEXT_PUBLIC_DATADOG_ENV,
  // Specify a version number to identify the deployed version of your application in Datadog
  version: "1.0.6",
  sessionSampleRate: 100,
  sessionReplaySampleRate: 20,
  trackUserInteractions: true,
  trackResources: true,
  trackLongTasks: true,
  trackSessionAcrossSubdomains: false,
  useSecureSessionCookie: false,
  useCrossSiteSessionCookie: false,
  // defaultPrivacyLevel: 'mask-user-input',
};

// Logs Config
export const datadogLogConfig = {
  clientToken: datadogRumconfig.clientToken,
  site: datadogRumconfig.site,
  forwardErrorsToLogs: true,
  sessionSampleRate: 100,
  env: datadogRumconfig.env,
  forwardConsoleLogs: ["error", "warn", "info"],
  service: datadogRumconfig.service,
  trackSessionAcrossSubdomains: true,
  useSecureSessionCookie: false,
  useCrossSiteSessionCookie: true,
  version: "1.0.6",
};

export const initDatadogConfig = () => {
  // Initialize Datadog rum configs Configs
  if (!datadogRum.getInitConfiguration()) {
    datadogRum.init(datadogRumconfig);
  }
  // Initialize Datadog Logs Configs
  if (!datadogLogs.getInitConfiguration()) {
    datadogLogs.init(datadogLogConfig);
  }
  datadogRum.startSessionReplayRecording();
};
